// Central project data. Each project has a `slug` used for its dedicated page
// at /projects/:slug. House Saunders keeps its own bespoke page component.

export const projects = [
  // Coming Soon projects first
  {
    id: "proj-oilwatch",
    slug: "oilwatch",
    title: "Oilwatch",
    category: "corporate",
    description: "A commercial interior design project for Oilwatch, creating functional and professional workspaces that align with the company's operational needs.",
    image_url: "coming-soon",
    images: [],
    location: "South Africa",
    services: ["Space Planning", "Interior Design", "Construction Drawings", "Project Management"],
    featured: false,
    comingSoon: true,
  },
  // VIP Boxes
  {
    id: "proj-vip-1",
    slug: "prescient-vip-box",
    title: "Prescient Fund Services VIP Box",
    category: "vip",
    description: "Elegant VIP hospitality suite at Newlands Cricket Stadium featuring deep navy panelled walls, premium leather seating, custom bar area, and panoramic views of the pitch.",
    coverLogo: "https://customer-assets.emergentagent.com/job_nh-spaces/artifacts/8fa56ya2_Prescient_Logo_RGB_Transparent%202.png",
    image_url: "logo-cover",
    images: [
      "https://customer-assets.emergentagent.com/job_nh-spaces/artifacts/fxcrptyl_PRES%203.jpeg",
      "https://customer-assets.emergentagent.com/job_nh-spaces/artifacts/cqr3d5x8_PRES%201.jpeg",
      "https://customer-assets.emergentagent.com/job_nh-spaces/artifacts/msd1hq3d_PRES%202.jpeg",
      "https://customer-assets.emergentagent.com/job_nh-spaces/artifacts/xwukak1t_PRES%204.jpeg",
    ],
    location: "Newlands Cricket Stadium, Cape Town",
    services: ["Space Planning", "Interior Design", "Custom Joinery", "Furniture Selection"],
    featured: true,
    enhanceColors: true,
  },
  {
    id: "proj-vip-2",
    slug: "pecuniae-vip-box",
    title: "Pecuniae Rentalis VIP Box",
    category: "vip",
    description: "Sophisticated corporate hospitality suite at Newlands Cricket Stadium designed for premium client entertainment and match day experiences. Features a lush green living wall, modern kitchen area with hexagonal tile splashback, pendant lighting, and panoramic pitch views.",
    coverText: "Pecuniae Rentalis",
    image_url: "text-cover",
    images: [
      "https://customer-assets.emergentagent.com/job_nh-spaces/artifacts/qc2iw4d5_WhatsApp%20Image%202026-04-09%20at%208.08.01%20AM.jpeg",
      "https://customer-assets.emergentagent.com/job_nh-spaces/artifacts/qw413eig_WhatsApp%20Image%202026-04-09%20at%208.08.02%20AM.jpeg",
      "https://customer-assets.emergentagent.com/job_nh-spaces/artifacts/iph0g0y4_WhatsApp%20Image%202026-04-09%20at%208.08.02%20AM%20%281%29.jpeg",
      "https://customer-assets.emergentagent.com/job_nh-spaces/artifacts/ptyeohio_WhatsApp%20Image%202026-04-09%20at%208.08.02%20AM%20%282%29.jpeg",
    ],
    location: "Newlands Cricket Stadium, Cape Town",
    services: ["Space Planning", "Interior Design", "Custom Joinery", "Furniture Selection"],
    featured: true,
  },
  // Corporate
  {
    id: "proj-prescient-silverwood",
    slug: "prescient-silverwood-office",
    title: "Prescient Silverwood Office",
    category: "corporate",
    description: "A completed corporate office fit-out for Prescient at their Silverwood premises — a calm, refined workspace blending warm timber tones, soft textures and considered lighting across the lounge, canteen and boardroom.",
    image_url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_nh-spaces/artifacts/ek5uv03n_Modern%20Prescient%20Lounge%20with%20Warm%20Accents.png",
    images: [
      "https://customer-assets-m6fa6gv7.emergentagent.net/job_nh-spaces/artifacts/ek5uv03n_Modern%20Prescient%20Lounge%20with%20Warm%20Accents.png",
      "https://customer-assets-m6fa6gv7.emergentagent.net/job_nh-spaces/artifacts/p1t9si34_canteen.jpeg",
      "https://customer-assets-m6fa6gv7.emergentagent.net/job_nh-spaces/artifacts/wik5nla1_meeting%20room.jpeg",
    ],
    location: "Silverwood, Cape Town",
    services: ["Space Planning", "Interior Design", "Custom Joinery", "Furniture Selection", "Project Management"],
    featured: true,
  },
  {
    id: "proj-sb",
    slug: "standard-bank",
    title: "Standard Bank Collaboration",
    category: "corporate",
    description: "Collaborating closely with Standard Bank and their design team, to successfully implement a cohesive office design.",
    coverLogo: "https://customer-assets.emergentagent.com/job_nh-spaces/artifacts/4e07fasn_standard-bank-vector-logo-small-removebg-preview.png",
    image_url: "logo-cover",
    images: [
      "https://customer-assets.emergentagent.com/job_nh-spaces/artifacts/xcpji8p2_Reception%201.jpg",
      "https://customer-assets.emergentagent.com/job_nh-spaces/artifacts/q8mo949w_Reception%202.jpg",
      "https://customer-assets.emergentagent.com/job_nh-spaces/artifacts/ji227wsb_Reception%203.jpg",
      "https://customer-assets.emergentagent.com/job_nh-spaces/artifacts/yn1u5djz_Reception%204.jpg",
      "https://customer-assets-m6fa6gv7.emergentagent.net/job_nh-spaces/artifacts/p0sh9gjf_Modern%20Executive%20Conference%20Room.png",
      "https://customer-assets-m6fa6gv7.emergentagent.net/job_nh-spaces/artifacts/ts99mt3d_Modern%20Conference%20Room%20with%20Warm%20Wood%20Accents.png",
      "https://customer-assets-m6fa6gv7.emergentagent.net/job_nh-spaces/artifacts/3z09nghv_Modern%20Light-Oak%20Boardroom%20Interior.png",
    ],
    location: "South Africa",
    services: ["Space Planning", "Design Development", "Project Management", "Construction Oversight"],
    featured: true,
  },
  {
    id: "proj-1",
    slug: "mweb-office",
    title: "Mweb Corporate Office",
    category: "corporate",
    description: "Modern open-plan office design featuring collaborative spaces, a welcoming staff lounge, and brand-integrated colour scheme.",
    image_url: "nh-cover",
    images: [
      "https://customer-assets.emergentagent.com/job_nh-spaces/artifacts/rt9kpxr1_IMG_1372.JPEG",
    ],
    location: "Cape Town",
    services: ["Space Planning", "Construction Drawings", "Project Management"],
    featured: true,
  },
  {
    id: "proj-2",
    slug: "pick-n-pay",
    title: "Pick n Pay",
    category: "corporate",
    description: "Contemporary workspace featuring ergonomic workstations, dedicated focus pods, and flexible meeting areas. The project progressed from detailed 3D renders to full construction.",
    coverLogo: "https://customer-assets.emergentagent.com/job_nh-spaces/artifacts/r9rto2od_Pnp.png",
    image_url: "logo-cover",
    images: [
      "https://customer-assets.emergentagent.com/job_nh-spaces/artifacts/470yltz4_Image%201.jpg",
      "https://customer-assets.emergentagent.com/job_nh-spaces/artifacts/w44tgcld_3d%20visual%201.jpg",
    ],
    location: "Cape Town",
    services: ["Space Planning", "3D Rendering", "Construction Drawings", "Project Management"],
    featured: true,
  },
  {
    id: "proj-4",
    slug: "vagabond-kitchens",
    title: "Vagabond Kitchens Cafe",
    category: "corporate",
    description: "Boutique cafe design combining industrial elements with organic textures and living plant installations.",
    image_url: "nh-cover",
    images: [
      "https://customer-assets.emergentagent.com/job_nh-spaces/artifacts/j8s20asd_Render%2002%20%281%29.png",
    ],
    location: "Cape Town",
    services: ["Space Planning", "Construction Drawings", "Council Submissions", "3D Rendering"],
    featured: true,
  },
  {
    id: "proj-oig",
    slug: "oig-optimum",
    title: "OIG / Optimum Investment Group",
    category: "corporate",
    description: "Heritage building renovation in Paarl, enhancing the original architectural features while modernising the interior office spaces. The concept bridges past and present — preserving the historic character of the building's exterior while creating sleek, contemporary workspaces inside.",
    coverLogo: "https://customer-assets.emergentagent.com/job_nh-spaces/artifacts/vsqf2qs8_Invest_Logo_square-removebg-preview.png",
    image_url: "logo-cover",
    images: [
      "https://customer-assets.emergentagent.com/job_nh-spaces/artifacts/px3r4f3g_Image1.png",
      "https://customer-assets.emergentagent.com/job_nh-spaces/artifacts/ap6zbvr3_Image1_000.png",
      "https://customer-assets.emergentagent.com/job_nh-spaces/artifacts/vy7ezncm_Image2.png",
      "https://customer-assets.emergentagent.com/job_nh-spaces/artifacts/r08p4r4q_Image3_000.png",
    ],
    location: "Paarl, Western Cape",
    services: ["Heritage Renovation", "Space Planning", "Construction Drawings", "3D Rendering", "Project Management"],
    featured: true,
    inProgress: true,
  },
  // Residential — keeps its own bespoke page
  {
    id: "proj-house-saunders",
    slug: "house-saunders",
    title: "333B \u2013 House Saunders",
    category: "residential",
    description: "House Saunders is a refined expression of timeless luxury, where carefully curated layers, rich materials and thoughtful detailing come together to create a home that feels both sophisticated and effortlessly comfortable.",
    image_url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_nh-spaces/artifacts/q6czf4k2_IMG_2492.webp",
    images: [
      "https://customer-assets-m6fa6gv7.emergentagent.net/job_nh-spaces/artifacts/q6czf4k2_IMG_2492.webp",
      "https://customer-assets-m6fa6gv7.emergentagent.net/job_nh-spaces/artifacts/3lpqkcy7_IMG_2499.webp",
      "https://customer-assets-m6fa6gv7.emergentagent.net/job_nh-spaces/artifacts/d7l7bviq_IMG_2552.webp",
    ],
    location: "Bantry Bay, Cape Town",
    services: ["Space Planning", "Construction Drawings", "Council Submissions", "Custom Furniture", "Turnkey Solution"],
    featured: true,
    dedicatedPage: "/projects/house-saunders",
  },
];

export const getProjectBySlug = (slug) => projects.find((p) => p.slug === slug);
